import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Field, Notice } from '@/components/ui';
import { DISPLAY_NAME_MAX_LENGTH } from '@/lib/text';
import { AuthShell } from './AuthShell';
import { useAuth } from './AuthContext';
import styles from './auth.module.css';

export function RegisterPage() {
  const { register } = useAuth();

  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  /** true, sobald der Account angelegt wurde und auf Freischaltung wartet. */
  const [done, setDone] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await register({ display_name: displayName, email, password });
      // §11.2/§11.5: kein Auto-Login — Hinweis auf Admin-Freischaltung zeigen.
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Registrierung fehlgeschlagen.');
    } finally {
      setSubmitting(false);
    }
  }

  if (done) {
    return (
      <AuthShell>
        <h1 className={styles.cardTitle}>Fast geschafft</h1>
        <Notice>
          Dein Konto wurde angelegt und wartet auf die Freischaltung durch einen Admin. Sobald es
          freigeschaltet ist, kannst du dich anmelden.
        </Notice>
        <p className={styles.altLink}>
          <Link to="/login">Zur Anmeldung</Link>
        </p>
      </AuthShell>
    );
  }

  return (
    <AuthShell>
      <h1 className={styles.cardTitle}>Registrieren</h1>
      <p className={styles.cardLead}>Erstelle dein Konto und tippe mit.</p>
      {error && <Alert>{error}</Alert>}
      <form onSubmit={onSubmit} noValidate>
        <Field
          id="displayName"
          label="Benutzername"
          autoComplete="nickname"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          maxLength={DISPLAY_NAME_MAX_LENGTH}
          required
        />
        <Field
          id="email"
          label="E-Mail"
          type="email"
          autoComplete="email"
          inputMode="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Field
          id="password"
          label="Passwort"
          type="password"
          autoComplete="new-password"
          minLength={8}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Button type="submit" disabled={submitting}>
          {submitting ? 'Wird erstellt…' : 'Konto erstellen'}
        </Button>
      </form>
      <p className={styles.altLink}>
        Bereits registriert? <Link to="/login">Anmelden</Link>
      </p>
    </AuthShell>
  );
}
